import styled from "@emotion/styled";

export const NavbarWrapper = styled.div`
  padding: 6px 0 6px 10px;
  height: 100dvh;
  position: sticky;
  top: 0;
  z-index: 1000;
`;
